import React from 'react'
import clsx from 'clsx'

import { ReactComponent as Solstice } from 'public/assets/solstice/images/Solstice.svg'

/* styling */
import styles from './_.module.css'
interface Props {
  title: string
  date: string
  time: string
  className?: string
}

const SolsticeHero: React.FC<Props> = ({ title, date, time, className }) => {
  return (
    <div className={clsx(className, styles.heroContainer)} id="solstice-hero">
      <div className="max-w-xl mx-auto | text-center">
        <Solstice />
      </div>
      <div className="max-w-lg mx-auto | text-center | pt-10">
        {title && <p className="h3">{title}</p>}
        <div className="flex items-center gap-4 justify-center">
          <div className="py-5">
            <span className="text-paragraph-4 | opacity-70">{date}</span>
            <span>{', '}</span>
            <span className="text-paragraph-4 | opacity-70">{time}</span>
          </div>
          <span>{' | '}</span>

          <a
            target="_blank"
            href="https://calendar.google.com/event?action=TEMPLATE&amp;tmeid=NmpmNm50cW1uMGFkMmMyZHFubzlxYWdqazkgY18xYmprMGNoMTkyazJzZjBkMDUzNWoyc2pjc0Bn&amp;tmsrc=c_1bjk0ch192k2sf0d0535j2sjcs%40group.calendar.google.com"
            rel="noreferrer"
            className="text-paragraph-4"
          >
            Add to Calendar
          </a>
        </div>
      </div>
    </div>
  )
}
export default SolsticeHero
